import React, { Component } from 'react';
import {connect} from "react-redux";
import {NavLink} from 'react-router-dom';
import { withRouter }     from 'react-router-dom';

import './page404.scss';
import * as routes from "../../constants/routes";

class Page404 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lastTimeoutId: 0,
        };
    }

    componentDidMount() {
        this.setState({
            ...this.state,
            lastTimeoutId: setTimeout(() => {
                this.props.history.push(routes.home);
            }, 2000),
        });
    }

    componentWillUnmount() {
        // If the component un-mounts for any reason (e.g. user switched to another page) - clear the timeout
        clearTimeout(this.state.lastTimeoutId);
    }

    render() {
        return (
            <div className="wrapper_404">
                <h1 className="title">{ this.props.text.web_404_title }</h1>
                <div className="bg">404</div>
                <NavLink to={routes.home} className='back-link'>{ this.props.text.web_404_btn_text }</NavLink>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return {
        text: store.config.Translations,
    }
}

export default withRouter(connect(mapStateToProps, null, null, { pure: false })(Page404));